export default __webpack_public_path__ + "static/media/home__start1.c576e96a.jpg";